import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';

/** Menu lateral: renderiza recursivamente os itens (via app-menuitem) a partir do modelo recebido. */
@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [AppMenuitem, RouterModule],
    template: `
        <div id="app-main-sidebar" class="layout-menu pe-2">
            <ul>
                @for (item of model(); track item; let i = $index) {
                    @if (!item.separator) {
                        <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
                    }
                    @if (item.separator) {
                        <li class="menu-separator"></li>
                    }
                }
            </ul>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppMenu {
    readonly model = input<MenuItem[]>([]);
}
